import { Box } from '@chakra-ui/react';
import { Text } from 'components/v4';
import { capitalizeFormattedDate } from 'utils/utils';

const SampleDateField = ({ values, FormFieldWithTooltip }) => {
    const formattedDate = new Intl.DateTimeFormat(
        values?.timeZone?.language ?? 'en-AU',
        {
            ...values?.timeZone,
        },
    ).format(new Date('2021-01-01T05:28:11.8022439Z'));

    return (
        <FormFieldWithTooltip
            label="Sample"
            tooltipLabel="This is a preview of how dates and times will be displayed based on your current settings."
            fieldKey="sample">
            <Box height="30px" display="flex" alignItems="center" width="100%">
                <Text color="gray.700" fontSize="sm">
                    {capitalizeFormattedDate(formattedDate)}
                </Text>
            </Box>
        </FormFieldWithTooltip>
    );
};

export default SampleDateField;
